import { create } from 'zustand';

/**
 * Turnos del agente EN VUELO por conversación (evento `agent.turn` del
 * backend, vía socket). Alimenta el indicador "Respondiendo…" del chat.
 * Guarda el timestamp de inicio para que la UI pueda auto-apagar un estado
 * pegado (si el `finished` se perdió por un reconnect del socket).
 */
interface AgentTurnsState {
  /** conversationId → epoch ms en que arrancó el turno. */
  respondingSince: Record<string, number>;
  setTurn: (conversationId: string, phase: 'started' | 'finished') => void;
}

export const useAgentTurnsStore = create<AgentTurnsState>((set) => ({
  respondingSince: {},
  setTurn: (conversationId, phase) =>
    set((s) => {
      const next = { ...s.respondingSince };
      if (phase === 'started') next[conversationId] = Date.now();
      else delete next[conversationId];
      return { respondingSince: next };
    }),
}));
